import { render, staticRenderFns } from "./r-block.vue?vue&type=template&id=59ecb404&scoped=true"
import script from "./r-block.vue?vue&type=script&lang=js"
export * from "./r-block.vue?vue&type=script&lang=js"
import style0 from "./r-block.vue?vue&type=style&index=0&id=59ecb404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecb404",
  null
  
)

export default component.exports